/**
 * Check if the path has a file extension
 *
 * @param {string} path
 */
export function hasExtension (path) {
  return fileExtension(path) !== null;
}

/**
 * Extract the file extension from a path
 *
 * @param {string} path
 */
export default function fileExtension (path = '') {
  // remove everything after the ? or #
  var base = path.replace(/([?|#].+$)/, '');

  // match the file extension
  var matches = base.match(/\.(\w+)$/);
  if (matches && matches[1]) {
    return matches[1];
  }

  return null;
};
